export const APP_URL = process.env.REACT_APP_BASE_URL;
export const FILE_URL = process.env.REACT_APP_FILE_URL;
export const MEDIA_URL = FILE_URL; // alias used by some components for clarity
export const API_URL = process.env.REACT_APP_API_URL;
export const MAIN_URL = process.env.REACT_APP_MAIN_URL;

export const absoluteUrl = (relativePath = '') => {
  const base = (process.env.REACT_APP_MAIN_URL || '').replace(/\/+$/, '');
  const path = String(relativePath || '').replace(/^\/+/, '');
  return `${base}${path ? `/${path}` : ''}`;
};

// export const FILE_URL = 'https://app-v1.bhajjamal.com';
// export const API_URL = 'https://app-v1.bhajjamal.com/api';

export const SITELOGO = require('./assets/image/logo-bhajjamal.png');
export const LOADING_IMG = require('./assets/image/bhajjamal-loading.gif');
export const NO_IMG = require('./assets/image/no-image.jpg');
export const VIDEO_THUMBNAIL = require('./assets/image/video-thumbnail.png');
export const BNR_1 = require('./assets/image/121.jpg');
export const BNR_2 = require('./assets/image/122.jpg');

export const APP_NAME = "Bhajjamal";
export const APP_VERSION = "1.0.0";
export const APP_AUTHOR = "Shiv Singh";
export const APP_AUTHOR_URL = "https://linkedin.com/tossraj";
export const APP_AUTHOR_EMAIL = "siswebdb@gmail.com";

export const cur = 'INR';
export const cur_prefix = 'Rs.';
export const country = 'Rs.';
export const phone_prefix = '+91';

export const MAX_TERMS = 20;
// Status Constants
// Must stay in sync with backend StatusConstants.php

export const ORDER_STATUSES = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    CANCELLATION_REQUEST: 'cancellation_request',
    VIRTUAL: 'virtual',
    SCHEDULED: 'scheduled'
};

export const SHIPPING_STATUSES = {
    NOT_REQUIRED: 'not_required',
    PENDING: 'pending',
    LABEL_REQUESTED: 'label_requested',
    LABEL_CREATED: 'label_created',
    READY_FOR_HANDOVER: 'ready_for_handover',
    PICKED_UP: 'picked_up',
    IN_TRANSIT: 'in_transit',
    OUT_FOR_DELIVERY: 'out_for_delivery',
    DELIVERED: 'delivered',
    RETURNED: 'returned',
    CANCELLED: 'cancelled',
    FAILED: 'failed',
};

export const PAYMENT_STATUSES = {
    PENDING: 'pending',
    PAID: 'paid',
    FAILED: 'failed',
    UNPAID: 'unpaid',
    REFUNDED: 'refunded',
};

/*
|--------------------------------------------------------------------------
| Status Labels (UI Display)
|--------------------------------------------------------------------------
*/
export const STATUS_LABELS = {
    // Order
    [ORDER_STATUSES.PENDING]: 'Pending',
    [ORDER_STATUSES.CONFIRMED]: 'Confirmed',
    [ORDER_STATUSES.IN_PROGRESS]: 'In Progress',
    [ORDER_STATUSES.COMPLETED]: 'Completed',
    [ORDER_STATUSES.CANCELLED]: 'Cancelled',
    [ORDER_STATUSES.CANCELLATION_REQUEST]: 'Cancellation Request',
    [ORDER_STATUSES.VIRTUAL]: 'Virtual',
    [ORDER_STATUSES.SCHEDULED]: 'Scheduled',

    // Shipping
    [SHIPPING_STATUSES.NOT_REQUIRED]: 'Not Required',
    [SHIPPING_STATUSES.PENDING]: 'Pending',
    [SHIPPING_STATUSES.LABEL_REQUESTED]: 'Label Requested',
    [SHIPPING_STATUSES.LABEL_CREATED]: 'Label Created',
    [SHIPPING_STATUSES.READY_FOR_HANDOVER]: 'Ready for Handover',
    [SHIPPING_STATUSES.PICKED_UP]: 'Picked Up',
    [SHIPPING_STATUSES.IN_TRANSIT]: 'In Transit',
    [SHIPPING_STATUSES.OUT_FOR_DELIVERY]: 'Out for Delivery',
    [SHIPPING_STATUSES.DELIVERED]: 'Delivered',
    [SHIPPING_STATUSES.RETURNED]: 'Returned',
    [SHIPPING_STATUSES.CANCELLED]: 'Cancelled',
    [SHIPPING_STATUSES.FAILED]: 'Failed',

    // Payment
    [PAYMENT_STATUSES.PENDING]: 'Pending',
    [PAYMENT_STATUSES.PAID]: 'Paid',
    [PAYMENT_STATUSES.FAILED]: 'Failed',
    [PAYMENT_STATUSES.UNPAID]: 'Unpaid',
    [PAYMENT_STATUSES.REFUNDED]: 'Refunded',
};

/*
|--------------------------------------------------------------------------
| Helpers
|--------------------------------------------------------------------------
*/
export const getStatusLabel = (status) =>
    STATUS_LABELS[status] || status;

export const getStatusVariant = (status) => {
    const variants = {
        // Order
        [ORDER_STATUSES.PENDING]: 'secondary',
        [ORDER_STATUSES.CONFIRMED]: 'info',
        [ORDER_STATUSES.CANCELLED]: 'danger',

        // Shipping
        [SHIPPING_STATUSES.NOT_REQUIRED]: 'light',
        [SHIPPING_STATUSES.PENDING]: 'secondary',
        [SHIPPING_STATUSES.LABEL_REQUESTED]: 'info',
        [SHIPPING_STATUSES.LABEL_CREATED]: 'primary',
        [SHIPPING_STATUSES.READY_FOR_HANDOVER]: 'warning',
        [SHIPPING_STATUSES.PICKED_UP]: 'info',
        [SHIPPING_STATUSES.IN_TRANSIT]: 'info',
        [SHIPPING_STATUSES.OUT_FOR_DELIVERY]: 'warning',
        [SHIPPING_STATUSES.DELIVERED]: 'success',
        [SHIPPING_STATUSES.RETURNED]: 'danger',
        [SHIPPING_STATUSES.CANCELLED]: 'danger',
        [SHIPPING_STATUSES.FAILED]: 'danger',
    };

    return variants[status] || 'secondary';
};
